<template>
  <div class="p-4 gap-3 bg-gray-800 rounded-lg text-gray-300 flex items-center border border-zinc-500" role="alert">
    <div class="text-blue-400">
      <DocsIconInfo class="mr-2 w-6 h-6" />
    </div>
    <div>
      <slot />
    </div>
  </div>
</template>
